import React from 'react';

import { DatabaseProps, ProjectTheme, TalentTrackerProps } from '@interfaces/projects';

import Database from './Layouts/Database';
import TalentTracker from './Layouts/TalentTracker';

// Combined type for the ProjectLayout component as a direct union
export type ProjectLayoutProps<TData, TValue> = DatabaseProps<TData, TValue> | TalentTrackerProps;

const ProjectLayout = <TData, TValue>(props: ProjectLayoutProps<TData, TValue>): JSX.Element => {
  const { project } = props;

  // Type guard to narrow the props based on project theme
  if (project.theme === ProjectTheme.TalentTracker) {
    return <TalentTracker {...(props as TalentTrackerProps)} />;
  } else {
    return <Database {...(props as DatabaseProps<TData, TValue>)} />;
  }
};

export default ProjectLayout;
